import { render, staticRenderFns } from "./reconsideracion-diaspora.vue?vue&type=template&id=2686c9ce&scoped=true&"
import script from "./reconsideracion-diaspora.component.ts?vue&type=script&lang=ts&"
export * from "./reconsideracion-diaspora.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2686c9ce",
  null
  
)

export default component.exports